import { Box } from "@chakra-ui/react";
import { FC } from "react";
import { useRouter } from "next/router";
import { useDnd, useDndAsset } from "domains/drag-and-drop";
import { usePackContext } from "domains/pack";
import { isEditable } from "../utils";
import { isPreviewingPack } from "lib/utils";
import { useLoggedinUser, usePack } from "lib/hooks";

export const BaseAssetWrapper: FC<any> = ({ setIsActive, children }) => {
  const { onSelectItem } = useDnd();
  const { path, isSelected, isDragging, asset } = useDndAsset();
  const { data: user } = useLoggedinUser();
  const { isDragInProgress } = useDnd();
  const { pathname } = useRouter();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);

  const canEdit = isEditable(asset, user, pack) && !isPreviewingPack(pathname);

  return (
    <Box
      onClick={canEdit ? (e) => onSelectItem(e, path) : null}
      layerStyle={['with-asset-wrapper', 'with-transition', !isDragInProgress && 'with-selectable-asset']}
      bgColor={isSelected ? 'brand.50' : 'white'}
      borderColor={(isSelected || isDragging) ? 'brand.500' : 'border.200' }
      gap={"15px"}
      id="dnd-asset"
      onMouseEnter={isDragInProgress ? null : () => setIsActive(true)}
      onMouseLeave={isDragInProgress ? null : () => setIsActive(false)}
    >
      { children }
    </Box>
  )
};
